import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { Link } from 'react-router-dom';
import { Users, Building, Settings, FileText, Key } from 'lucide-react';

export function AdminPage() {
  const { hasPermission } = useAuth();

  const adminCards = [
    {
      title: 'Benutzer',
      description: 'Benutzer verwalten und Rollen zuweisen',
      icon: Users,
      href: '/admin/users',
      permissions: ['admin.users.view'],
    },
    {
      title: 'Mandanten',
      description: 'Anstalten und Mandanten konfigurieren',
      icon: Building,
      href: '/admin/tenants',
      permissions: [],
    },
    {
      title: 'Audit-Log',
      description: 'Systemprotokoll und Änderungshistorie',
      icon: FileText,
      href: '/admin/audit',
      permissions: ['admin.audit.view'],
    },
    {
      title: 'KI-Einstellungen',
      description: 'LLM/Embedding, Feature-Flags und Scope-Freigaben',
      icon: Settings,
      href: '/admin/ai-settings',
      permissions: ['admin.ai-settings.view'],
    },
    {
      title: 'Sicherheit',
      description: 'Zugriffsrechte und Schutzstufen',
      icon: Key,
      href: '/admin/security',
      permissions: ['admin.roles.view'],
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Administration</h1>
        <p className="text-muted-foreground">
          Systemverwaltung und Konfiguration
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {adminCards
          .filter((card) => card.permissions.length === 0 || card.permissions.some((permission) => hasPermission(permission)))
          .map((card) => (
            <Card key={card.title} className="hover:shadow-md transition-shadow">
              <CardHeader>
                <div className="flex items-center gap-3">
                  <div className="rounded-lg bg-primary/10 p-2">
                    <card.icon className="h-5 w-5 text-primary" />
                  </div>
                  <CardTitle className="text-lg">{card.title}</CardTitle>
                </div>
                <CardDescription>{card.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <Button variant="outline" asChild className="w-full">
                  <Link to={card.href}>Öffnen</Link>
                </Button>
              </CardContent>
            </Card>
          ))}
      </div>
    </div>
  );
}
